export default __webpack_public_path__ + "static/media/primer.5938ad9a.png";